import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorSSOOtpSearch = () => {
  const otpSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/sso/otp/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { otpSearch }
}

export default InteractorSSOOtpSearch
